'use client';

import useAccordion from '@/hooks/useAccordion';
import { FC, PropsWithChildren, useRef } from 'react';
import { BrandsAccordionProps } from './types';
import FilledLeftArrow from '@/components/Icon/FilledLeftArrow';
import { clsx } from 'clsx';
import styles from './BrandsAccordion.module.css';

const BrandsAccordion: FC<PropsWithChildren<BrandsAccordionProps>> = ({ children, letter }) => {
  const brandsAccordionRef = useRef<HTMLDivElement>(null);
  const { height, handleAccordionOpen, isShortListOpened } = useAccordion({
    shortListRef: brandsAccordionRef,
    isOpened: false,
    duration: 300,
  });
  return (
    <>
      <div
        onClick={handleAccordionOpen}
        className={styles.brandsListAccordionHeader}
        data-testid={`brand-accordion-header-${letter}`}
      >
        {letter}
        <FilledLeftArrow width="12" height="12" className={clsx({ [styles.arrowOpen]: isShortListOpened.current })} />
      </div>
      <div
        style={{ height }}
        className={styles.brandsListContent}
        ref={brandsAccordionRef}
        data-testid={`brand-accordion-content-${letter}`}
      >
        {children}
      </div>
    </>
  );
};

export default BrandsAccordion;
